import { z } from "zod";
import { StatusButton } from "#app/components/ui/status-button.tsx";

const OAUTH2_PROVIDER_NAME = "oauth2";

const providerNames = [OAUTH2_PROVIDER_NAME] as const;
export const ProviderNameSchema = z.enum(providerNames);
export type ProviderName = z.infer<typeof ProviderNameSchema>;

export const providerLabels: Record<ProviderName, string> = {
  [OAUTH2_PROVIDER_NAME]: "OAuth2",
} as const;

export function ProviderConnectionForm({
  redirectTo,
  providerName,
  buttonClassName,
  buttonText = "Login",
}: {
  redirectTo?: string | null;
  type: "Connect" | "Login" | "Signup";
  providerName: ProviderName;
  /** Optional class for the submit button (e.g. landing brand styles) */
  buttonClassName?: string;
  /** Optional button label (default: "Login") */
  buttonText?: string;
}) {
  const formAction = `/auth/${providerName}`;
  return (
    // Native form (not Remix <Form>): OAuth actions return a 302 to Keycloak.
    // Remix client-side submission follows that redirect as a data request,
    // never handing off to the browser — Login appears to do nothing.
    <form
      className="flex items-center justify-center gap-2"
      action={formAction}
      method="POST"
    >
      {redirectTo ? (
        <input type="hidden" name="redirectTo" value={redirectTo} />
      ) : null}
      <StatusButton
        type="submit"
        className={
          buttonClassName ??
          "w-full outline-none focus-within:shadow-none! focus-within:ring-0! focus-within:ring-offset-0!"
        }
        status="idle"
      >
        <span className="inline-flex items-center gap-1.5">
          <span>{buttonText}</span>
        </span>
      </StatusButton>
    </form>
  );
}
